export const QUESTIONNAIRE = {
   PUBLISHED_STATUS: 'PUBLICADO',
   DRAFT_STATUS: 'BORRADOR',
   PROGRAMMED_STATUS: 'PROGRAMADO',
   INACTIVE_STATUS: 'INACTIVO'
}
